import React from 'react'
import MultiLine from 'components/Charts_MultiLine'
import { addDays, formatSwissDate } from 'components/Charts_Assets'
import './styles.scss'

import glacierData from 'data/glaciers.json'

const isSmallMobile = window.innerWidth <= 320

export class SmallMultiples extends React.Component<Props, State> {
  constructor() {
    super()
    this.state = {
      curveData: glacierData,
      isLimited: true
    }
  }

  showMore() {
    this.setState({ isLimited: false })
    // track in google analytics
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'Interactions',
      event_action: 'click',
      event_label: `show-more: Small Multiples`
    })
  }

  render() {
    return (
      <div className='ui smallmultiples container'>
        <div
          className={
            this.props.isMobile ? 'two column grid ui' : 'five column grid ui'
          }
          style={{ marginTop: '1em' }}
        >
          {this.state.curveData &&
            this.state.curveData.map((m, i) => {
              if (!this.state.isLimited || i <= (this.props.isMobile ? 3 : 4)) {
                return (
                  <div className='column'>
                    <div className='linechart' key={'linechart-' + i}>
                      <div className='chart-title'>
                        <h5>{m[0]}</h5>
                        <span className='canton'>
                          <img
                            src={require('../../images/kantone/' +
                              m[1] +
                              '.svg')}
                          />
                        </span>
                      </div>
                      <div className='volume'>
                        {Math.round(m[2][0].vol * 100) / 100} km<sup>3</sup>
                      </div>
                      <MultiLine
                        data={[
                          m[2]
                            .filter((f, i) => i < m[2].length - 1)
                            .map(m => {
                              return { d: m.d, v: m.opt }
                            }),
                          m[2]
                            .filter((f, i) => i < m[2].length - 1)
                            .map(m => {
                              return { d: m.d, v: m.pess }
                            })
                        ]}
                        yDomain={[100, 0]}
                        xDomain={[
                          new Date(
                            new Date(m[2][0].d).getFullYear() - 15 + '-01-01'
                          ),
                          new Date(m[2][m[2].length - 1].d)
                        ]}
                        yTicks={{
                          lines: [0, 25, 50, 75, 100],
                          text: [25, 50, 75, 100],
                          unit: '%'
                        }}
                        height={140}
                        xTicks={{
                          text: !isSmallMobile
                            ? [
                                '2025-01-01',
                                '2050-01-01',
                                '2075-01-01',
                                '2100-01-01'
                              ]
                            : ['2050-01-01', '2100-01-01'],
                          lines: !isSmallMobile
                            ? [
                                '2025-01-01',
                                '2050-01-01',
                                '2075-01-01',
                                '2100-01-01'
                              ]
                            : ['2050-01-01', '2100-01-01']
                        }}
                        className='glacier-loss'
                      />
                    </div>
                  </div>
                )
              }
            })}
        </div>
        {this.state.isLimited && (
          <div className='showmore'>
            <button onClick={() => this.showMore()} className='ui button'>
              mehr zeigen
            </button>
          </div>
        )}
      </div>
    )
  }
}
